import { Routes, Route } from "react-router-dom";
import OverviewPage from "../pages/OverviewPage";
import DataHubPage from "../pages/DataHubPage";
import GradesDemPage from "../pages/GradesDemPage";
import CurvatureGeometryPage from "../pages/CurvatureGeometryPage";
import OngoingPage from "../pages/OnGoingPage";
import LeftDrawer from "../components/LeftDrawer";

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<LeftDrawer />}>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/data-hub" element={<DataHubPage />} />
        <Route path="/grades-dem" element={<GradesDemPage />} />
        <Route path="/curvature-geometry" element={<CurvatureGeometryPage />} />
        <Route path="/settings" element={<OngoingPage title="Settings" />} />
        <Route path="/help" element={<OngoingPage title="Help" />} />
      </Route>
    </Routes>
  );
}